export default "__VITE_ASSET__CpTKqoRT__"